import useFacebookAnalyticsStore from 'src/hooks/useFacebookAnalyticsStore';
import { FetchAttr } from '../types';
import { postData } from '../utils';

export type PostEventAddToCartRequest = {
  translitName: string;
  unitQuantity: number;
  packQuantity: number;
};

const postEventAddToCart = async (
  requestObj: PostEventAddToCartRequest,
  attr?: FetchAttr
): Promise<void> => {
  const { fbclid, fbp } = useFacebookAnalyticsStore.getState();
  const paramsString = new URLSearchParams({
    ...(fbclid && { fbc: fbclid }),
    ...(fbp && { fbp }),
    'User-Agent': window.navigator.userAgent
  });
  await postData(`event/add_to_cart?${paramsString.toString()}`, requestObj, {
    ...attr
  });
};

export default postEventAddToCart;
